// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-containers-templates-public-public-template-js": () => import("./../../../src/components/containers/templates/public/PublicTemplate.js" /* webpackChunkName: "component---src-components-containers-templates-public-public-template-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

